var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Group } from '@/models/Group';
import { Curriculum } from '@/models/Curriculum';
import ErrorHandler from '@/support/ErrorHandler';
import LoaderCard from '@/components/loader-card/LoaderCard.vue';
import AreaRow from '@/components/area-row/AreaRow';
import { Subject } from '@/models/Subject';
import SelectFilter from '@/components/select-filter/SelectFilter';
let SubjectSelector = class SubjectSelector extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        // protected groupClone: Group = {} as Group;
        this.selectedAll = false;
        this.selectedSubjects = [];
        // protected searchInput = '';
        // protected searchDebounce = this.handleSearch();
        this.isLoading = true;
        this.subjects = [];
        this.curriculum = new Curriculum();
        this.filters = {
            periods: [],
            levels: [],
        };
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    // protected mounted(): void {
    //   this.initialize();
    // }
    // protected async initialize(): Promise<void> {
    //   this.isLoading = true;
    //   this.groupClone = cloneDeep(this.group);
    //   this.isLoading = false;
    // }
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.fetchCurrentCurriculum();
        if (this.curriculum.id) {
            await this.fetchSubjects();
        }
        this.isLoading = false;
    }
    async fetchCurrentCurriculum() {
        try {
            this.curriculum = await new Curriculum()
                .current()
                .first();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async fetchSubjects() {
        try {
            this.subjects = await new Subject()
                .filter({
                curriculum: this.curriculum.id
            })
                .limit(100)
                .include('children')
                .all();
            this.curriculum.subjects = this.subjects;
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    close() {
        this.$emit('input', false);
    }
    onSelectedSubjectsChanged(subjects) {
        console.log('subjects', subjects);
        this.$emit('update:selectedSubjects', subjects);
    }
    // #endregion
    // #region Async methods (api calls only)
    // #endregion
    // #region Getters & Setters
    // #endregion
    // #region @Watchers
    onSubjectsChanged(subjects) {
        console.log('subjects: ', subjects);
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], SubjectSelector.prototype, "group", void 0);
__decorate([
    Watch('subjects'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], SubjectSelector.prototype, "onSubjectsChanged", null);
SubjectSelector = __decorate([
    Component({
        components: {
            LoaderCard,
            AreaRow,
            SelectFilter
        }
    })
], SubjectSelector);
export default SubjectSelector;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
